import { Link } from '@remix-run/react'
import { /*  useEffect, useRef, */ useState } from 'react'

interface Heading {
	id: string
	text: string | null
	heading: string | null
}
const TableOfContents = (props: { headings: Heading[] }) => {
	const headings = props.headings
	const [activeId, setActiveId] = useState('')

	const handleLinkClick = (id: string) => {
		const targetElement = document.getElementById(id)
		if (targetElement) {
			targetElement.scrollIntoView({ behavior: 'smooth' })
			setActiveId(id)
		}
	}

	return (
		<>
			{headings.length > 0 && (
				<>
					<div className="space-y-2">
						<h3 className="mb-3 text-xs font-semibold uppercase text-fuchsia-600">
							En esta página
						</h3>
						<ul>
							{headings.map(({ text, id, heading }) => (
								<li
									key={id}
									className={
										'pb-1 leading-tight ' + (heading === 'h3' ? 'pl-4' : '')
									}
								>
									<Link
										className={
											'text-sm  hover:text-primary ' +
											(activeId === id
												? 'font-bold text-fuchsia-600'
												: 'font-normal  text-gray-500')
										}
										to={id}
										onClick={(e: any) => {
											e.preventDefault()
											//@ts-ignore
											handleLinkClick(id)
										}}
										style={{
											fontWeight: activeId === id ? 'bold' : 'normal',
										}}
									>
										{text}
									</Link>
								</li>
							))}
						</ul>
					</div>
				</>
			)}
		</>
	)
}

export { TableOfContents }
